import React, { FC } from 'react'
import { RegisterOptions } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { FormStateType } from '../../../types'
import {
  Form, Grid, LabelWrapper, LineInput, Button, Row, Checkbox
} from '../../System'
import { Controller } from '../../System/Form'
import ROUTES from '../../utils/routes'
import { useRegisterHandler } from '../../Auth'

type Props = {
  form: FormStateType;
  validation: { [x: string]: RegisterOptions };
  nextStep: () => void;
}

const MainInfoStep: FC<Props> = ({ form, validation, nextStep }) => {
  const { actions: { checkIfEmailExists } } = useRegisterHandler()
  const {
    values, control, formState, setValue, getError
  } = form

  const validatePhoneNumber = (phoneNumber: string) => {
    const formattedNumber = phoneNumber.replace(/[^0-9]/g, '')
    setValue('phoneNumber', formattedNumber)
  }

  return (
    <Form>
      <Grid inLayout gap={12}>
        <Row columns={2}>
          <LabelWrapper label="Full Name" errorMessage={getError('firstName')}>
            <Controller
              name="firstName"
              control={control}
              rules={validation.firstName}
              component={<LineInput placeholder="First Name" />}
            />
          </LabelWrapper>
          <LabelWrapper label=" " errorMessage={getError('lastName')}>
            <Controller
              name="lastName"
              control={control}
              rules={validation.lastName}
              component={<LineInput placeholder="Last Name" />}
            />
          </LabelWrapper>
        </Row>

        <LabelWrapper label="Email Address" errorMessage={getError('emailAddress')}>
          <Controller
            name="emailAddress"
            control={control}
            rules={{
              ...validation.emailAddress,
              validate: { value: async (value) => (await checkIfEmailExists(value)) || 'Email already exists' }
            }}
            component={<LineInput placeholder="jasmine@star.com" />}
          />
        </LabelWrapper>

        <LabelWrapper label="Password" errorMessage={getError('password')}>
          <Controller
            name="password"
            control={control}
            rules={validation.password}
            component={<LineInput placeholder="Password" type="password" />}
          />
        </LabelWrapper>

        <Checkbox
          onChange={(checked) => setValue('optIn', checked.target.checked)}
          name="opt-in"
          label="Yes! I'd like to receive customer support via text, account updates, and Social Curator surprise perks!"
        />

        {!!values.optIn && (
          <LabelWrapper label="Phone Number" errorMessage={getError('phoneNumber')}>
            <Controller
              name="phoneNumber"
              control={control}
              rules={validation.phoneNumber}
              onChange={(e) => validatePhoneNumber(e.target.value)}
              component={<LineInput maxLength={10} overrideInput placeholder="1234567890" />}
            />
          </LabelWrapper>
        )}
      </Grid>
      <Button
        isDisabled={!formState.isDirty || (values.optIn && !values.phoneNumber)}
        type="large"
        className="continue-btn"
        onClick={() => nextStep()}
      >
        CONTINUE
      </Button>
      <span className="auth-prompt">
        Already have an account? <Link to={ROUTES.user.login}>Sign In</Link>
      </span>
    </Form>
  )
}

export default MainInfoStep
